import { EAsymmetryFlag } from '../../../data/providers/reports/asymmetryReportProvider';

export const namespaceLabel = (slot: number, label: string): string => {
  return `${slot}:${label}`;
};

export const displayNamespacedLabel = (label: string): string => {
  const labelParts = label.split(':');
  return labelParts.length > 1 ? labelParts[1] : labelParts[0];
};

export const ASYMMETRY_COLORS = {
  [EAsymmetryFlag.CRITICAL]: 'var(--color-material-500-red)',
  [EAsymmetryFlag.WARN]: 'var(--color-material-500-yellow)',
  [EAsymmetryFlag.NONE]: 'var(--color-material-500-green)',
  baseline: 'rgba(255, 255, 255, 0.2)',
};
